<fui-pop-button [title]="title"
                [toggled]="popped"
                [disabled]="disabled"
                (blur)="onBlur($event)" (focus)="onFocus($event)">
    <fui-mark-toggle [toggled]="popped">
        <fui-icon [height]="6" [icon]="'chevron-down'" [width]="12"></fui-icon>
    </fui-mark-toggle>
</fui-pop-button>
<fui-select-pop [popped]="popped" (popped$)="pop($event)" [limitWidthToParent]="false"
                [parentHorizontalAlignment]="parentHorizontalAlignment">
    <fui-sections>
        <fui-content-section *ngIf="loading && !query">
            <fui-loading>
                <fui-ellipsis-loader></fui-ellipsis-loader>
            </fui-loading>
        </fui-content-section>
        <fui-fab-section *ngIf="searchable()">
            <fui-search-control [label]="'fui.select-control.label.filter' | translate" [(ngModel)]="query"
                                [placeholder]="'fui.select-control.placeholder.filter' | translate"></fui-search-control>
        </fui-fab-section>
        <fui-content-section *ngIf="empty(filteredOptions)">
            <fui-empty>
                <fui-icon [height]="32" [icon]="'search-group'" [width]="32"></fui-icon>
            </fui-empty>
        </fui-content-section>
        <fui-section *ngIf="filled(filteredOptions)">
            <fui-select-options [field]="valueField" [key]="labelField"
                                [options]="options" [filteredOptions]="filteredOptions"
                                id="options"
                                [allowClearSelectionOption]="false"
                                [optionOpenable]="false"
                                [getOptionMetaData]="getOptionMetaData"
                                (selection$)="select($event)"></fui-select-options>
        </fui-section>
        <fui-ftb-section *ngIf="ftb()">
            <fui-fragments>
                <fui-fragment *ngIf="showAddOption || showExtendedSearchOption || actions">
                    <fui-buttons>
                        <fui-mark-button (click)="extend()" *ngIf="showExtendedSearchOption"
                                         [attr.title]="'fui.common.button.search' | translate"
                                         id="extended-search-button">
                            <fui-icon [height]="12" [icon]="'lookup'" [width]="12"></fui-icon>
                        </fui-mark-button>
                        <fui-mark-button (click)="add()" *ngIf="showAddOption"
                                         [attr.title]="'fui.common.button.addNew' | translate"
                                         id="add-new-button">
                            <fui-icon [height]="12" [icon]="'plus'" [width]="12"></fui-icon>
                        </fui-mark-button>
                        <fui-action *ngFor="let a of actions" [disabled]="a.disabled" [attr.title]="a.title | translate"
                                    (click)="actionClicked(a)">
                            <fui-icon [height]="a.iconHeight || 12" [width]="a.iconWidth || 12"
                                      [icon]="a.icon"></fui-icon>
                        </fui-action>
                    </fui-buttons>
                </fui-fragment>
                <fui-fragment *ngIf="limited()">
                    <fui-limit-total [limit]="filteredOptions.length" [total]="total"></fui-limit-total>
                </fui-fragment>
            </fui-fragments>
        </fui-ftb-section>
    </fui-sections>
</fui-select-pop>
